import React from 'react';
import Button from '../../form-elements/Button';

const ContinueShoppingButton = ({ continueShopping }) => {
    return (
        <div className="uk-margin-small-top">
            <Button modifier="default" onClick={continueShopping}>
                WEITER EINKAUFEN
            </Button>
            <div className="cartBorder" />
        </div>
    );
};

export default ContinueShoppingButton;
